<style lang="scss">
@import '../css/sub.scss';
</style>
<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template sub-template">
      <div role="sub" class="audit-sub">
        <div id="sub-sections">
          <div class="visual-top report-complete">
            <h2 class="page-tit">제보확인</h2>
            <p class="page-sub-tit pc-show">Clean :D의 모든 제보는 접수순서에 따라 순차적으로 처리함을 원칙으로 합니다.<br>
            접수부터 사실관계 확인 및 조치완료까지 최소 2주부터 최대 1개월 이상 소요될 수 있으니 참고하시기 바랍니다.<br>
            (6하 원칙에 의거한 제보사항이 구체적일수록 처리기간을 단축할 수 있습니다.)<br>
            제보사항에 대해서는 최대한 신속하고 정확하게 처리하겠습니다.<br>
            </p>
          </div>
          <div class="col-container pc-container">
            <div class="sub-contents">
              <section class="sub-section inquiry-section">
                <h3 class="inquiry-tit">제보결과 확인</h3>
                <div class="inquiry-desc">
                  <p class="top-txt">제보 접수 당시 안내 받으신 <br class="m-show"><span class="default-color">제보접수번호 및 비밀번호</span>를 입력해 주세요.</p>
                  <div class="form-container">
                    <div class="form-group">
                      <div class="input-area">
                        <label class="blind" for="reception-number">접수번호</label>
                        <input
                          class="default-input"
                          type="text"
                          id="reception-number"
                          v-model="numberVal"
                          :class="{'reception': receptionNumber}"
                          placeholder="제보접수번호">
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="input-area">
                        <label class="blind" for="user-password">비밀번호</label>
                        <input
                          class="default-input"
                          type="password"
                          id="user-password"
                          v-model="passwordVal"
                          :class="{'reception': receptionPassword}"
                          placeholder="비밀번호">
                      </div>
                    </div>
                    <p class="error" v-if="reception" :class="{ active : reception }">{{receptionMessage}}</p>
                    <div class="inquiry-btn">
                        <button class="default-btn" type="button" @click="inquiry">조회</button>
                    </div>
                  </div>
                </div>
                <p class="inquiry-notice"><i class="icon"></i>접수번호와 비밀번호를 입력하여 주십시오.( 결과 답변완료후 1개월이 경과하면 개인정보보호를 위해 신고내용 및 처리결과를 확인할 수 없습니다. )</p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
// import { mapActions } from 'vuex'
export default {
  name: 'ReportInquiry',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter
  },
  data () {
    return {
      numberVal: '',
      passwordVal: '',
      receptionPassword: false,
      receptionNumber: false,
      reception: false,
      receptionMessage: ''
    }
  },
  methods: {
    inquiry () {
      const params = {
        loginId: this.numberVal,
        password: this.passwordVal,
        timestamp: Math.floor(+new Date() / 1000)
      }
      if (this.numberVal === '' || this.passwordVal === '') {
        this.receptionMessage = '접수번호 또는 비밀번호를 입력해주세요.'
        this.reception = true
      } else {
        this.$store.dispatch('apiInformantSignin', params)
        this.reception = false
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/ReportInquiry.vue